import { mixed, number, object } from "yup";

export enum PriceCurrency {
  PLN = "PLN",
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
}

export interface PriceMoneyResource {
  amount: number;
  currency: PriceCurrency;
}

export const priceMoneyResourceSchema = object({
  amount: number().required(),
  currency: mixed<PriceCurrency>()
    .oneOf(Object.values(PriceCurrency) as PriceCurrency[])
    .required(),
});
